var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-collapsible-listbox',{attrs:{"toggle-text":_vm.toggleText,"items":_vm.$options.PAGE_SIZES,"selected":_vm.value},on:{"select":function($event){return _vm.emitInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }